import React from 'react';
import { Layout } from 'antd';

import PageHeader from './page-header';
import { useStore } from './store';

import './cyber-security-training.less';
import './cyber-security-training.mobile.less';

interface IPageLayoutProps {
  pageName: string;
  noHeader?: boolean;
  pageClass?: string;
}

const PageLayout: React.FunctionComponent<IPageLayoutProps> = (props) => {
  const { page, language } = useStore();
  if (!page) {
    return <div>Loading...</div>;
  }
  const idToClass = (id: string) =>
    ({
      'general-staff': 'cybersecurity2025',
    }[id]);
  return (
    <div
      className={`cyber-security-training-page ${props.pageName} ${language} ${
        props.pageClass === 'general-staff'
          ? idToClass(props.pageClass as string)
          : props.pageClass
      } ${process.env.REACT_APP_DOMAIN}-page`}
    >
      <Layout>
        {props.noHeader !== undefined && props.noHeader ? null : <PageHeader />}
        <Layout.Content>{props.children}</Layout.Content>
      </Layout>
    </div>
  );
};

export default PageLayout;
